// @flow
import {
  take,
  select,
} from 'redux-saga/effects'

import {mapSelectors} from '../selectors'
import {mapActions} from '../actions'
 
export function* ensureMapReady():Effect {
  const isReady:boolean = yield select(mapSelectors.isReady) 
  if (!isReady) {
    yield take(mapActions.setReady.id)
  }
}